import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import ReactDOM from 'react-dom';

// 'Minimal' theme - hide/show the AccordionBody component:
import 'react-accessible-accordion/dist/minimal-example.css';
 
import {
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';


class ScheduleITem extends React.Component {
    render(){

    const {key1, time, presenter, title, description, space} = this.props;

    if (space == true){
        return(
            <AccordionItem key={key1}>
                <AccordionItemTitle>
                    <header className="schedule-header">
                        <time className="schedule-header_time">{time}</time>
                        <div className="schedule-header_wrapper">
                            <h3 className="schedule-header_name">{title}</h3>
                        </div>
                    </header>
                </AccordionItemTitle>
                <AccordionItemBody>
                    <p className="schedule-body">{description}</p>
                </AccordionItemBody>
            </AccordionItem>
        )
    } else {
        return(
            <AccordionItem key={key1}>
                <AccordionItemTitle>
                    <header className="schedule-header">
                        <time className="schedule-header_time">{time}</time>
                        <div className="schedule-header_wrapper">
                            <h3 className="schedule-header_person">{presenter}</h3>
                            <p className="schedule-header_title">{title}</p>
                        </div>
                    </header>
                </AccordionItemTitle>
                <AccordionItemBody>
                    <p className="schedule-body">{ReactHtmlParser(description)}</p>
                </AccordionItemBody>
            </AccordionItem>
        )
    }
}}

export default ScheduleITem


// WEBPACK FOOTER //
// ./src/components/ScheduleItem/index.js